import { DataGridFeatureConfig } from '@waseel-asp/tpa-waseel-lib-staging';
import { GRID_PAGE_DEFAULT_SIZE } from "../../../../../../shared/constants/grid-constant";
import { PATH_CONFIG_ENCOUNTER } from '../../../../../../shared/constants/route-consts';

export interface IEncounterClass {
    encounterClassId: string,
    typeId: string,
    typeNameArabic: string,
    typeNameEnglish: string,
    subtypeId: string,
    subTypeNameEnglish: string,
    subTypeNameArabic: string,
    code: string,
    nameEnglish: string,
    nameArabic: string,
    descriptionEnglish: string,
    descriptionArabic: string
}

export const encounterClassConfig = {
    entityName: "CONFIGURATION.ENCOUNTER_CLASS.TITLE",
    type: "CONFIGURATION.CLAIM_TYPE.TITLE",
    subType: "CONFIGURATION.CLAIM_TYPE.SUB_TYPES",
    code: 'FORM_FIELD.CODE',
    nameEnglish: 'FORM_FIELD.ENGLISH_NAME',
    nameArabic: 'FORM_FIELD.ARABIC_NAME',
    descriptionEnglish: 'FORM_FIELD.ENGLISH_DESCRIPTION',
    descriptionArabic: 'FORM_FIELD.ARABIC_DESCRIPTION',
    uploadExcelData: 'FORM_FIELD.UPLOAD_EXCEL_DATA',
    importTemplateDownload: "COMMON.IMPORT_TEMPLATE_DOWNLOAD"
};

export const encounterClassRoutes = {
    encounterClassDetails: `${PATH_CONFIG_ENCOUNTER}/view/`,
    encounterClassEdit: `${PATH_CONFIG_ENCOUNTER}/edit/`,
    encounterClassAdd: `${PATH_CONFIG_ENCOUNTER}/add`,
    encounterClass: PATH_CONFIG_ENCOUNTER
};

export const encoubterClassGridFeatures: DataGridFeatureConfig<IEncounterClass> = {
    showPagination: true,
    enableApiSearching: true,
    enableApiSorting: true,
    allowSearching: false,
    allowSorting: true,
    allowHideShowColumns: true,
    allowExpandRow: false,
    showCheckboxSelection: false,
    stickyFeature: {
        isStickyHeader: true
    },
    paginatorFeatures: {
        defaultPagesize: GRID_PAGE_DEFAULT_SIZE,
        totalCount: 0,
        enableApiPagination: true
    }
};